var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerreno2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.51,
    height: 52.01,
    viewBox: "0 0 44.51 52.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f8f8f8;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    className: "cls-1",
    width: 44.51,
    height: 52.01
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Terreno_White",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    "data-name": "Group 848",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3171",
    "data-name": "Path 3171",
    className: "cls-1",
    d: "M44.48,47.4,41.079,23.8a2.472,2.472,0,0,0-2.412-2.1h-1.3a1.025,1.025,0,0,0-1.028.823.988.988,0,0,0,.975,1.154h1.377a.46.46,0,0,1,.454.4l1.671,11.695-5.55,2.081-4.61-6.569a.973.973,0,0,0-1.6.009l-.016.023a.975.975,0,0,0-.009,1.11l1.3,1.9L12.847,38.744,9.941,35.057,16.4,32.8a.989.989,0,1,0-.741-1.833L8.685,33.434,6.708,30.9l-2.6,2.051,1.27-8.9a.461.461,0,0,1,.455-.4H7.71a1.024,1.024,0,0,0,1.027-.822.989.989,0,0,0-.975-1.155H5.811a2.473,2.473,0,0,0-2.412,2.1L.026,47.4A2.68,2.68,0,0,0,2.309,50.42a2.533,2.533,0,0,0,.36.026H41.814a2.679,2.679,0,0,0,2.7-2.662,2.59,2.59,0,0,0-.026-.387ZM2.794,43.33l9.311-2.358,5.906,7.5H6.842Zm3.569-9.647,4.4,5.589L2.9,41.249l.781-5.471ZM2.146,48.233a.683.683,0,0,1-.173-.558l.267-1.849,2.085,2.645H2.665a.679.679,0,0,1-.519-.237Zm40.182,0a.679.679,0,0,1-.519.237H20.528l-6.322-8.027L23.36,38.13l3.005,5.792,1.754-.888-2.792-5.4,6.227-1.576,2.17,3.024L29.236,46.6l1.7,1.017,4.651-7.769,5.5-2.071L42.5,47.666a.69.69,0,0,1-.173.568Z",
    transform: "translate(0 1.564)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3172",
    "data-name": "Path 3172",
    className: "cls-1",
    d: "M12.339,9.338a1.232,1.232,0,0,0-1.694.41l0,0v.023a1.233,1.233,0,0,0,2.106,1.261v-.023a1.233,1.233,0,0,0-.41-1.674",
    transform: "translate(0.759 0.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3173",
    "data-name": "Path 3173",
    className: "cls-1",
    d: "M35.424,14.967a10.822,10.822,0,0,0-.925-3.253A8.219,8.219,0,0,0,28,7.355,5.7,5.7,0,0,0,22.448,0a5.258,5.258,0,0,0-2.626.7,5.718,5.718,0,0,0-2.85,5.934,8.543,8.543,0,0,0-2.288.77,1.027,1.027,0,0,0,.923,1.835,6.471,6.471,0,0,1,2.723-.693,1.023,1.023,0,0,0,.891-1.462,3.07,3.07,0,0,1-.071-2.9c1.882-3.148,5.655-2.509,6.764.087a3.631,3.631,0,0,1-.387,3.539,1.026,1.026,0,0,0,.954,1.615,5.484,5.484,0,0,1,2.656.166A6.346,6.346,0,0,1,33.4,15.528a6.108,6.108,0,0,1-1.908,4.456,1.015,1.015,0,0,0-.136,1.324,5.114,5.114,0,0,1-8.365,5.885V25.253l2.589-2.59,2.462,1.35a1.025,1.025,0,1,0,1.077-1.743.9.9,0,0,0-.094-.051l-1.939-1.062,1-1a1.025,1.025,0,0,0-1.447-1.45l-1.95,1.95-1.691,1.694V13.465a1.026,1.026,0,1,0-2.052,0v3.911L17.689,14.12a1.025,1.025,0,1,0-1.45,1.45l4.6,4.6a1,1,0,0,0,.109.092v6.485l-.041.064a5.192,5.192,0,0,1-6.492,2.067,5.016,5.016,0,0,1-1.134-8.352,1,1,0,0,0,.145-1.406,6.462,6.462,0,0,1-1.4-4.042,1.026,1.026,0,1,0-2.052,0,8.48,8.48,0,0,0,1.311,4.548,7.061,7.061,0,0,0,9.664,10.223v4.528a1.021,1.021,0,1,0,2.041,0V30.055a7.162,7.162,0,0,0,10.485-9.19,8.094,8.094,0,0,0,1.774-3.539,14.559,14.559,0,0,0,.181-2.359",
    transform: "translate(0.685 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerreno2);
export default __webpack_public_path__ + "static/media/Terreno2.35402178fdd61561801244d55c646666.svg";
export { ForwardRef as ReactComponent };